// extracted by mini-css-extract-plugin
export default {"menu":"RightMenu_menu__T8xbr","createButtonVisible":"RightMenu_createButtonVisible__qRsae","emailVisible":"RightMenu_emailVisible__VSNlF"};